module.exports = __webpack_public_path__ + "img/no-order-found.6c441df6.gif";